import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ImageOrderingPageRoutingModule } from './image-ordering-routing.module';

import { ImageOrderingPage } from './image-ordering.page';
import { SharedModule } from '@shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClientModule } from '@angular/common/http';
import { ImageOrderingChooseFileComponent } from '@order/components/image-ordering/image-ordering-choose-file/image-ordering-choose-file.component';
import { ImageOrderingLoadingComponent } from '@order/components/image-ordering/image-ordering-loading/image-ordering-loading.component';
import { ImageOrderingResultComponent } from '@order/components/image-ordering/image-ordering-result/image-ordering-result.component';
import { ImageOrderingTableComponent } from '@order/components/image-ordering/image-ordering-table/image-ordering-table.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ImageOrderingPageRoutingModule,
    SharedModule,
    TranslateModule,
    HttpClientModule,
  ],
  declarations: [
    ImageOrderingPage,
    ImageOrderingChooseFileComponent,
    ImageOrderingLoadingComponent,
    ImageOrderingResultComponent,
    ImageOrderingTableComponent,
  ],
})
export class ImageOrderingPageModule {}
